export enum Types {
  LOGIN = "LOGIN",
  USER_AGENT_REDUCER = "USER_AGENT_REDUCER",
  DIAL_PAD_OPEN = "DIAL_PAD_OPEN",
  MERGE_DIALPAD = "MERGE_DIALPAD",
  CONFERENCE_USER_LIST = "CONFERENCE_USER_LIST",
  INCOMING_CALL_POPUP = "INCOMING_CALL_POPUP",
  OUTGOING_CALL_POPUP = "OUTGOING_CALL_POPUP",
  DIAL_PAD_CHANGES = "DIAL_PAD_CHANGES",
  FLOW = "FLOW",
  SELECTED_NODE = "SELECTED_NODE",
  FLOW_UPDATE = "FLOW_UPDATE",
  LOGIN_LOADING = "LOGIN_LOADING",
  INITIAL_MENU = "INITIAL_MENU",
  SETUP_EDIT = "SETUP_EDIT",
  AGENT_LOADING = "AGENT_LOADING",
  SETUP_CREATE = "SETUP_CREATE",
  INITIAL_LOADING = "INITIAL_LOADING",
  ADD_DTMFINPUT = "ADD_DTMFINPUT",
  STORE_MESSAGE = "STORE_MESSAGE",
  CONVERSATION_NAV = "CONVERSATION_NAV",
  POPUP_MESSAGE = "POPUP_MESSAGE",
  POPUP_CALL = "POPUP_CALL",
  WORKING_STATUS = "WORKING_STATUS",
  GET_CONTACT_LIST = "GET_CONTACT_LIST",
  CHAT_SESSION_LIST = "CHAT_SESSION_LIST",
  CURRENT_CHAT_SESSION = "CURRENT_CHAT_SESSION",
  UPDATE_MESSAGE = "UPDATE_MESSAGE",
  TRACK_AGENT = "TRACK_AGENT",
  MONITOR_TYPE = "MONITOR_TYPE",
  SIDE_BAR_OVERLAY_SETTINGS = "SIDE_BAR_OVERLAY_SETTINGS",
  DO_OPEN_AUDIO_PLAYER = "DO_OPEN_AUDIO_PLAYER",
  ADD_RESPONSE_URL = "ADD_RESPONSE_URL",
  CHAT_CONFIG_PLAYLOAD = "CHAT_CONFIG_PLAYLOAD",
  BASIC_CHAT_SETINGS = "BASIC_CHAT_SETINGS",
  PERSONALIZATION = "PERSONALIZATION",
  PRIMARY_FORM = "PRIMARY_FORM",
  IS_SAVE = "IS_SAVE",
  CODE_SNIPPET = "CODE_SNIPPET",
  FORM_ERROR = "FORM_ERROR",
  DIALED_NUMBER = "DIALED_NUMBER",
  SIDE_BAR_OVERLAY_COLLAPSE = "SIDE_BAR_OVERLAY_COLLAPSE",
  SETTING_MENU = "SETTING_MENU",
  CONTACTS_MENU = "CONTACTS_MENU",
  SIDE_BAR_OVERLAY_CLOSE_SETTINGS = "SIDE_BAR_OVERLAY_CLOSE_SETTINGS",
  PROMPT_LIBRARY_DATA = "PROMPT_LIBRARY_DATA",
  QUEUE_TRACKER_DATA = "QUEUE_TRACKER_DATA",
  AGENT_TRACKER_DATA = "AGENT_TRACKER_DATA",
  ROUTING_PROFILE_DATA = "ROUTING_PROFILE_DATA",
  USER_MANAGEMENT = "USER_MANAGEMENT",
  QUEUE_LIST = "QUEUE_LIST",
  AGENT_STATUS = "AGENT_STATUS",
  SKILL_MANAGEMENT = "SKILL_MANAGEMENT",
  CUSTOMER_TAG_DATA = "CUSTOMER_TAG_DATA",
  BUSINESS_HOURS = "BUSINESS_HOURS",
  CONTACT_CENTRE_NUMBER = "CONTACT_CENTRE_NUMBER",
  QUEUE_LIST_ENABLE = "QUEUE_LIST_ENABLE",
  SKILL_MANAGEMENT_ENABLE = "SKILL_MANAGEMENT_ENABLE",
  ROUTING_PROFILE_ENABLE = "ROUTING_PROFILE_ENABLE",
  GET_CALLFLOW_LIST = "GET_CALLFLOW_LIST",
  WEB_CHAT_LIST = "WEB_CHAT_LIST",
  CONTACTS = "CONTACTS",
  SIDE_BAR_OVERLAY_CONTACTS = "SIDE_BAR_OVERLAY_CONTACTS",
  SIDE_BAR_OVERLAY_REPORTS = "SIDE_BAR_OVERLAY_REPORTS",
  SIDE_BAR_OVERLAY_CLOSE_CONTACTS = "SIDE_BAR_OVERLAY_CLOSE_CONTACTS",
  LEFT_MENU_VALUES = "LEFT_MENU_VALUES",
  INTERNAL_CHAT = "INTERNAL_CHAT",
  UPDATE_CONTACT_PROFILE = "UPDATE_CONTACT_PROFILE",
  SIDE_BAR_OVERLAY = "SIDE_BAR_OVERLAY",
  SIDE_BAR_OVERLAY_CLOSE = "SIDE_BAR_OVERLAY_CLOSE",
  TRANSFER_TYPE = "TRANSFER_TYPE",
  USER_LOGOUT = "USER_LOGOUT",
  NOTIFICATION = "NOTIFICATION",
  INTERVAL_REPORT = "INTERVAL_REPORT",
  ABANDONED_CALL_REPORT = "ABANDONED_CALL_REPORT",
  DISPOSITION_STATUS = "DISPOSITION_STATUS",
  QUEUE_BASE_INBOUND_CALL = "QUEUE_BASE_INBOUND_CALL",
  GET_CHATFLOW_LIST = "GET_CHATFLOW_LIST",
  TEMPLATE_BOT = "TEMPLATE_BOT",
  CLOSE_CAPTION = "CLOSE_CAPTION",
  TRANSCRIPTS_LIST = "TRANSCRIPTS_LIST",
  TRANSCRIPTS_LIST_EDIT = "TRANSCRIPTS_LIST_EDIT",
  SPEAKER_LANG = "SPEAKER_LANG",
  AUDIO_LANG = "AUDIO_LANG",
  CC_LANG = "CC_LANG",
  TRANSCRIPTS_FILTER = "TRANSCRIPTS_FILTER"
}








export enum meetActionTypes {
  // Message Action Types
  ADD_MESSAGE = 'ADD_MESSAGE',
  STORE_CONVERSATION = 'STORE_CONVERSATION',
  CHAT_MORE_OPTION = 'CHAT_MORE_OPTION',
  CHAT_TRIGGER = 'CHAT_TRIGGER',
  UPDATE_MEET_DETAILS = 'UPDATE_MEET_DETAILS',
  SOCKET_MEETING_DETAILS = 'SOCKET_MEETING_DETAILS',
  UPDATE_WORK_CONTACT = 'UPDATE_WORK_CONTACT',
  UPDATE_FAV_CONTACT = 'UPDATE_FAV_CONTACT',
  SOCKET_ERROR = 'SOCKET_ERROR',
  ADD_LOGIN = 'ADD_LOGIN',
  ADD_TOKEN = 'ADD_TOKEN',
  SOCKET_LOADING = 'SOCKET_LOADING',
  UPDATE_AUDIO_STREAM = 'UPDATE_AUDIO_STREAM',
  UPDATE_VIDEO_STREAM = 'UPDATE_VIDEO_STREAM',
  UPDATE_ACTIVE_PARTICIPANT = 'UPDATE_ACTIVE_PARTICIPANT',
  SOCK_THANK = 'SOCK_THANK',
  END_POPUP_MSG = 'END_POPUP_MSG',
  SOCKET_JOIN = 'SOCKET_JOIN',
  OPEN_WR = 'OPEN_WR',
  PIN_UPDATE = 'PIN_UPDATE',
  UNMUTE_REQ = 'UNMUTE_REQ',
  CHAT_TO_PARTICIPANTS = 'CHAT_TO_PARTICIPANTS',
  RECORD_UPDATE = 'RECORD_UPDATE',
  SHOW_RECORDING = 'SHOW_RECORDING',
  RECORD_MEETING_POPUP_MSG = 'RECORD_MEETING_POPUP_MSG',
  RECORD_POPUP = 'RECORD_POPUP',
  TOGGLE_VIDEO = 'TOGGLE_VIDEO',
  TOGGLE_VIDEO_DELAY = 'TOGGLE_VIDEO_DELAY',
  TOGGLE_AUDIO = 'TOGGLE_AUDIO',
  UNMUTE_PART_REQ = 'UNMUTE_PART_REQ',
  LOCK_MEETING_POPUP_MSG = 'LOCK_MEETING_POPUP_MSG',
  UPDATE_PREVIOUS_VIEW_STATUS = 'UPDATE_PREVIOUS_VIEW_STATUS',
  CHAT_WINDOW_OPEN = 'CHAT_WINDOW_OPEN',
  TRANSCRIPTS_LIST = 'TRANSCRIPTS_LIST',
  NEWTASK_WINDOW_OPEN = 'NEWTASK_WINDOW_OPEN',
  UPDATE_IN_STATUS = 'UPDATE_IN_STATUS',
  TRANSCRIPTS_ADD_KEYWORD = 'TRANSCRIPTS_ADD_KEYWORD',
  TRANSCRIPTS_HIGHLIGHTS = 'TRANSCRIPTS_HIGHLIGHTS',
  TRANSCRIPTS_LIST_EDIT = 'TRANSCRIPTS_LIST_EDIT',
  TRANSCRIPTS_SPEAKER = 'TRANSCRIPTS_SPEAKER',
  CC_LANG = 'CC_LANG',
  UPDATE_RECOG_STATUS = 'UPDATE_RECOG_STATUS',
  UPDATE_VOICE_SDK = 'UPDATE_VOICE_SDK',
  UPDATE_CONN_STATUS = 'UPDATE_CONN_STATUS',
  UPDATE_ARROW_KEY = 'UPDATE_ARROW_KEY',
  FULL_SCREEN = 'FULL_SCREEN',
  UPDATE_MEET_STATUS = 'UPDATE_MEET_STATUS',
  TEAM_CONTACT = 'TEAM_CONTACT',
  AUTO_DRAGGABLE = 'AUTO_DRAGGABLE',
  CURRENT_PARTICIPANT = 'CURRENT_PARTICIPANT',
  BROWSER_TYPE = 'BROWSER_TYPE',
  ICE_CONNECTION_STATE = 'ICE_CONNECTION_STATE',
  IS_SOCKET_INIT = 'IS_SOCKET_INIT',
  IS_TRANSPORT_CLOSE = 'IS_TRANSPORT_CLOSE',
  HOST_REQ_AUD_VDE_KEY = 'HOST_REQ_AUD_VDE_KEY',
  MUTE_STATUS = 'MUTE_STATUS',
  UPDATE_INSTANT_LOADER = 'UPDATE_INSTANT_LOADER',
  REC_TIMER = 'REC_TIMER',
  SCROLL = 'SCROLL',
  TRANSCRIPTS_FILTER = 'TRANSCRIPTS_FILTER',
  ASK_TO_JOIN_BUTTON = 'ASK_TO_JOIN_BUTTON',
  SSO_TOKEN_CLIENT_DOMAIN = 'SSO_TOKEN_CLIENT_DOMAIN',
  AGENT_VIDEO = "AGENT_VIDEO",
  CLOSE_CAPTION = "CLOSE_CAPTION",
  CC_STATUS = "CC_STATUS",
  AUDIO_LANG = "AUDIO_LANG",
  QUEUE_ANNOUNCEMENT = "QUEUE_ANNOUNCEMENT",
  SPEAKER_LANG = "SPEAKER_LANG",
  MEETING_CONTROL_OPEN = "MEETING_CONTROL_OPEN",
  CUSTOMER_CONTROL_OPEN="CUSTOMER_CONTROL_OPEN",
  SMS_DETAILS="SMS_DETAILS",
  CHAT_RECEIVE_ARRAY="CHAT_RECEIVE_ARRAY",
  VIDEO_CALL_DETAILS='VIDEO_CALL_DETAILS',
  RESET_VM_DETAILS='RESET_VM_DETAILS',
  SET_DURATION='SET_DURATION',
  UPDATE_VIRTUAL_BG ='UPDATE_VIRTUAL_BG',
  UPDATE_TEMP_VIRTUAL_BG = 'UPDATE_TEMP_VIRTUAL_BG',
  UPDATE_VIRTUAL_TEMP = 'UPDATE_VIRTUAL_TEMP',
  UPDATE_VIRTUAL_TF = 'UPDATE_VIRTUAL_TF',
  UPDATE_VIRTUAL_STATUS = 'UPDATE_VIRTUAL_STATUS',
  VM_SETTINGS='VM_SETTINGS',
  RECORD_TRANSCRIPT='RECORD_TRANSCRIPT',
  VM_TRANSFER='VM_TRANSFER',
  VM_TRANSFER_TIME='VM_TRANSFER_TIME',
  VERIFICATION_MODAL='VERIFICATION_MODAL',
  FACE_VERIFICATION_DETAILS='FACE_VERIFICATION_DETAILS',
  FACE_VERIFICATION_IMG_INFO='FACE_VERIFICATION_IMG_INFO',
  VERFICATION_MSG='VERFICATION_MSG',
  VERIFICATION_ATTACHMENTS='VERIFICATION_ATTACHMENTS',
  DOC_MODAL='DOC_MODAL'
}

export enum actionTypes {
  CREATE_CALL_UA = 'CREATE_CALL_UA',
  UPDATE_WHITEBOARD = 'UPDATE_WHITEBOARD',
  START_WHITEBOARD = 'START_WHITEBOARD',
  ANNOTATE='ANNOTATE',
  RESIZE_CANVAS='RESIZE_CANVAS',
  ANNOTATION_STATUS='ANNOTATION_STATUS',
  SCREENSHARING_STATUS = 'SCREENSHARING_STATUS',
  MEDIADEVICEINFO = 'MEDIADEVICEINFO',
  PARTICIPANT_VIDEO_INFO = 'PARTICIPANT_VIDEO_INFO',
  CALL_WAITING_STATUS = 'CALL_WAITING_STATUS',
  CALL_SYNC_STORE = 'CALL_SYNC_STORE',
  CALL_STATUS = 'CALL_STATUS',
  ACTIVE_SPEAKER = 'ACTIVE_SPEAKER',
  VIDEO_RESOLUTION = 'VIDEO_RESOLUTION',
  VIDEO_BANDWIDTH = 'VIDEO_BANDWIDTH',
  PIN_PARTICIPANT = 'PIN_PARTICIPANT',
  MULTI_INVITE_CHECK='MULTI_INVITE_CHECK'
}
